module.exports = __webpack_public_path__ + "img/app_multi_site.7fff27ab.svg";